import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App';
import { startServiceWorker } from './app/providers/service-worker';
import { isPublicReportPath } from './app/router/paths';
import './app/styles/global.css';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Geen #root gevonden in index.html');
}

createRoot(container).render(
    <StrictMode>
        <App />
    </StrictMode>,
);

/*
 * Een nieuwe versie herlaadt de pagina nooit vanzelf; zie `startServiceWorker`.
 * Niet op de klantpagina: een koper installeert geen app en hoeft de hele app niet
 * vooraf te downloaden.
 */
if (!isPublicReportPath(window.location.pathname)) {
    startServiceWorker();
}
